<div class="background">
  <div class="price-container" [class.small]="small()">
    <span class="bestprice-label">
      <span class="bestprice-label-prefix">Ihr</span> Bestpreis
    </span>
    <span class="price">
      <ui-product-prices-formatter
        [price]="price()"
        [showThousandthsPlace]="showThousandthsPlace()"
      ></ui-product-prices-formatter>
    </span>
  </div>
</div>
